<script>
import NewItemForm from './components/new-item-supplier-form.vue';
import SelectItemForm from './components/select-item-supplier-form.vue';

export default {
  components: {
    SelectItemForm,
    NewItemForm,
  },
  props: {
    supplierIdPublic: { type: String, default: null },
    useOrderConstraintsQuantities: { type: Boolean, default: false },
  },
  data() {
    return {
      isCreateItem: false,
    };
  },
  methods: {
    itemToAdd(info) {
      this.$emit('item-supplier-to-add', {
        itemSupplier: info.item.itemSuppliers[0],
        quantity: info.quantity,
        orderUnitQuantity: 1,
      });
    },
    itemSupplierToAdd(info) {
      this.$emit('item-supplier-to-add', info);
    },
  },
};
</script>

<template>
  <div class="d-flex">
    <div
      class="flex-vertical-align pl-3 pr-3"
      style="cursor: pointer; font-size: 1.7em; padding-top: 26px"
      @click="isCreateItem = !isCreateItem"
    >
      <i v-if="isCreateItem" class="fas fa-list-ul"></i>
      <i v-else class="fas fa-plus"></i>
    </div>
    <div class="flex-grow-1">
      <SelectItemForm
        v-if="!isCreateItem"
        :supplierIdPublic="supplierIdPublic"
        @item-supplier-to-add="itemSupplierToAdd"
        :useOrderConstraintsQuantities="useOrderConstraintsQuantities"
      />
      <NewItemForm
        v-else
        :supplierIdPublic="supplierIdPublic"
        @item-to-add="itemToAdd"
      />
    </div>
  </div>
</template>

<style scoped>
.quantity-group {
  min-width: 130px;
  max-width: 130px;
}
</style>
